import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { getRoleId, isLoggedIn, logout } from "./session";
import { roleHome } from "./roleHome";
import { Forbidden } from "./fallbacks";

// Sends a visitor without a usable session to the login page. Whatever is
// left of the session (a token whose role this app does not serve, or a role
// cookie without a token) is cleared first, so the shell can't be reopened by
// typing a URL. logout() only removes cookies / storage, so it is safe here.
function ToLogin({ from }) {
  logout();
  return <Redirect to={{ pathname: "/pages/login", state: from ? { from } : undefined }} />;
}

// Route guard. Signed out -> the login page. Signed in with a role that is
// not in `roles` -> a "no access" page inside the shell. Without `roles`
// any signed-in role may open the page.
//   <RequireRole roles={[7]}><PayoutRuns /></RequireRole>
export default function RequireRole({ roles, children }) {
  const location = useLocation();
  if (!isLoggedIn()) return <ToLogin from={location.pathname + location.search} />;
  if (roles && roles.length && !roles.includes(getRoleId())) return <Forbidden roles={roles} />;
  return children;
}

// "/" -> the signed-in role's home page (or the login page).
export const HomeRedirect = () => (isLoggedIn() ? <Redirect to={roleHome()} /> : <ToLogin />);
